<template>
  <DashboardLayout class="client" :class="isClientViewing ? 'client-view' : ''">
    <!-- Actives  -->
    <CardsSectionClientActives :title="$t('client.dashboard.active_actions')" class="actives" />
    <!-- Inactives  -->
    <CardsSection
      collapse
      :title="$t('client.dashboard.inactive_actions')"
      class="inactives"
      :items-length="getCardsByStatus(['paused', 'completed']).length"
      :transition-duration="500"
    >
      <CardsSectionBlock>
        <CardSingle
          v-for="card in getCardsByStatus(['paused', 'completed'])"
          :key="card.id"
          :card="card"
        />
      </CardsSectionBlock>
    </CardsSection>
    <!-- footer -->
    <!-- <TheFooter v-if="isClientViewing" /> -->
  </DashboardLayout>
</template>

<script>
// Utitlities
import { authComputed } from 'Store/helpers'
import { clientGetters } from 'Store/helpers'

// Components
import CardSingle from 'Modules/Card/CardSingle'
import CardsSection from 'Components/CardsSection'
import DashboardLayout from 'Layouts/DashboardLayout'
import CardsSectionBlock from 'Components/CardsSectionBlock'
import CardsSectionClientActives from 'Components/CardsSectionClientActives'

export default {
  name: 'DashboardClient',

  components: {
    CardSingle,
    CardsSection,
    DashboardLayout,
    CardsSectionBlock,
    CardsSectionClientActives,
  },

  computed: {
    ...authComputed,
    ...clientGetters,
    isClientViewing() {
      return this.userType === 'CLIENT'
    },
  },

  async beforeRouteUpdate(to, from, next) {
    if (from.params.account_id !== to.params.account_id)
      // reloading account data
      await this.$store.dispatch('client/load', to.params.account_id)
    next()
  },
}
</script>

<style scoped>
.dashboard__wrapper.client-view {
  padding-bottom: 100px;
}

.client .cards-section:last-of-type {
  margin-bottom: 0;
}

.client >>> .cards-section__block-wrapper .app-grid__listing {
  padding: 10px 20px 20px;
}

@media (min-width: 581px) {
  .client >>> .cards-section.actives .app-grid:not(.single-cards) .card-single.two-slots {
    grid-column-end: span 2;
  }

  .client >>> .cards-section.actives .card-single.three-slots {
    grid-column-end: span 3;
  }
}
</style>
